export default ({ intl, plan }) => [
  {
    planId: "0",
    permissions: [
      {
        name: intl.formatMessage({ id: "billing.plan.extensionAvailable" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.saveEditExportLeads" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.tasksManagement" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.emailer" }),
        toolTip: intl.formatMessage({ id: "billing.plan.emailerTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.dialer" }),
        toolTip: intl.formatMessage({ id: "billing.plan.dialerTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.integrations" }),
        toolTip: intl.formatMessage({ id: "billing.plan.integrationsTooltip" }),
      },
      {
        name: intl.formatMessage(
          { id: "billing.plan.upToLists" },
          { value: plan.maxLists }
        ),
        toolTip: intl.formatMessage({ id: "billing.plan.upToListsTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.enrichmentWk" }),
        toolTip: intl.formatMessage({ id: "billing.plan.enrichmentWkTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.enrichmentWkLaunches" }),
        toolTip: intl.formatMessage({
          id: "billing.plan.enrichmentWkLaunchesTooltip",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.defaultLinkedinSequences",
        }),
        toolTip: intl.formatMessage({
          id: "billing.plan.defaultLinkedinSequencesTooltip",
        }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.publicApiAccess" }),
        toolTip: "",
      },
    ],
  },
  {
    planId: "plan_1",
    permissions: [
      {
        name: intl.formatMessage({ id: "billing.plan.extensionAvailable2" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.creditsRollOver" }),
        toolTip: intl.formatMessage({
          id: "billing.plan.creditsRollOverTooltip",
        }),
      },
      {
        name: intl.formatMessage(
          { id: "billing.plan.upToLists" },
          { value: plan.maxLists }
        ),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.zapierIntegration" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage(
          { id: "billing.plan.xEnrichmentWorkflows" },
          { value: plan.enrichmentPerSearch }
        ),
        toolTip: null,
      },
      {
        name: intl.formatMessage(
          { id: "billing.plan.workflowLaunches" },
          { value: plan.numberOfWorkflowLaunches, x: plan.contactPerLaunch }
        ),
        toolTip: intl.formatMessage({
          id: "billing.plan.workflowLaunchesTooltip",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.unlimitedLinkedinSequences",
        }),
        toolTip: null,
      },
    ],
  },
  {
    planId: "plan_2",
    permissions: [
      {
        name: intl.formatMessage({
          id: "billing.plan.extensionAvailable3",
        }),
        toolTip: null,
      },
      {
        name: intl.formatMessage(
          {
            id: "billing.plan.adminSeats",
          },
          { value: plan.maxAdmins }
        ),
        toolTip: intl.formatMessage({
          id: "billing.plan.adminSeatsTooltype",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.unlimitedLists",
        }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.unlimitedEnrichWk",
        }),
        toolTip: null,
      },
      {
        name: intl.formatMessage(
          {
            id: "billing.plan.wkLaunchesPerMonth",
          },
          {
            value:
              plan.numberOfWorkflowLaunches == -1
                ? intl.formatMessage({ id: "billing.unlimited" })
                : plan.numberOfWorkflowLaunches,
          }
        ),
        toolTip: intl.formatMessage({
          id: "billing.plan.wkLaunchesPerMonthTooltip",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.customMemberPermissions",
        }),
        toolTip: intl.formatMessage({
          id: "billing.plan.customMemberPermissionsTooltip",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.report&Activity",
        }),
        toolTip: null,
      },
    ],
  },
  {
    planId: "plan_3",
    permissions: [
      {
        name: intl.formatMessage(
          {
            id: "billing.plan.adminSeats",
          },
          { value: plan.maxAdmins }
        ),
        toolTip: null,
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.tailoredOnboarding",
        }),
        toolTip: null,
      },
      {
        name: intl.formatMessage(
          {
            id: "billing.plan.unlimitedWorkflowsLaunches",
          },
          { value: plan.contactPerLaunch }
        ),
        toolTip: intl.formatMessage({
          id: "billing.plan.unlimitedWorkflowsLaunchesTooltip",
        }),
      },
    ],
  },
  {
    planId: "plan_11",
    permissions: [
      {
        name: intl.formatMessage({ id: "billing.plan.extensionAvailable" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.saveEditExportLeads" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.tasksManagement" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.emailer" }),
        toolTip: intl.formatMessage({ id: "billing.plan.emailerTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.dialer" }),
        toolTip: intl.formatMessage({ id: "billing.plan.dialerTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.integrations" }),
        toolTip: intl.formatMessage({ id: "billing.plan.integrationsTooltip" }),
      },
      {
        name: intl.formatMessage(
          { id: "billing.plan.upToLists" },
          { value: plan.maxLists }
        ),
        toolTip: intl.formatMessage({ id: "billing.plan.upToListsTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.enrichmentWk" }),
        toolTip: intl.formatMessage({ id: "billing.plan.enrichmentWkTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.enrichmentWkLaunches" }),
        toolTip: intl.formatMessage({
          id: "billing.plan.enrichmentWkLaunchesTooltip",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.defaultLinkedinSequences",
        }),
        toolTip: intl.formatMessage({
          id: "billing.plan.defaultLinkedinSequencesTooltip",
        }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.publicApiAccess" }),
        toolTip: "",
      },
    ],
  },
  {
    planId: "plan_12",
    permissions: [
      {
        name: intl.formatMessage({ id: "billing.plan.extensionAvailable" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.saveEditExportLeads" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.tasksManagement" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.listManagement" }),
        toolTip: null,
      },
    ],
  },
  {
    planId: "custom",
    permissions: [
      {
        name: intl.formatMessage({ id: "billing.plan.extensionAvailable" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.saveEditExportLeads" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.tasksManagement" }),
        toolTip: null,
      },
      {
        name: intl.formatMessage({ id: "billing.plan.emailer" }),
        toolTip: intl.formatMessage({ id: "billing.plan.emailerTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.dialer" }),
        toolTip: intl.formatMessage({ id: "billing.plan.dialerTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.integrations" }),
        toolTip: intl.formatMessage({ id: "billing.plan.integrationsTooltip" }),
      },
      {
        name:
          plan.maxLists == -1
            ? intl.formatMessage(
                { id: "billing.plan.unlimitedLists" },
                { value: plan.maxLists }
              )
            : intl.formatMessage(
                { id: "billing.plan.upToLists" },
                { value: plan.maxLists }
              ),
        toolTip: intl.formatMessage({ id: "billing.plan.upToListsTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.enrichmentWk" }),
        toolTip: intl.formatMessage({ id: "billing.plan.enrichmentWkTooltip" }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.enrichmentWkLaunches" }),
        toolTip: intl.formatMessage({
          id: "billing.plan.enrichmentWkLaunchesTooltip",
        }),
      },
      {
        name: intl.formatMessage({
          id: "billing.plan.defaultLinkedinSequences",
        }),
        toolTip: intl.formatMessage({
          id: "billing.plan.defaultLinkedinSequencesTooltip",
        }),
      },
      {
        name: intl.formatMessage({ id: "billing.plan.publicApiAccess" }),
        toolTip: "",
      },
    ],
  },
];
